import { render, staticRenderFns } from "./DCacheTable.vue?vue&type=template&id=99497cfe&scoped=true&"
import script from "./DCacheTable.vue?vue&type=script&lang=js&"
export * from "./DCacheTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99497cfe",
  null
  
)

export default component.exports